module.exports = __webpack_public_path__ + "static/media/Sprint_ProductPurchaseGuidance.aef8697b.jpg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/experiences/resources/ExperienceCards/SHS-SPRINT/Sprint_ProductPurchaseGuidance.jpg
// module id = 3767
// module chunks = 0